import { render, staticRenderFns } from "./InfosLegales.vue?vue&type=template&id=769c9f30&scoped=true&"
import script from "./InfosLegales.vue?vue&type=script&lang=ts&"
export * from "./InfosLegales.vue?vue&type=script&lang=ts&"
import style0 from "./InfosLegales.vue?vue&type=style&index=0&id=769c9f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c9f30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
